<template>
    <transition>
        <div class="preloader-box" v-if="loading.preloader">
            <svg width="76" height="76" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_1_3" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
                <circle cx="28" cy="28" r="28" fill="#C4C4C4"/>
                </mask>
                <path id="circle-loader" d="M28 55C24.4543 55 20.9433 54.3016 17.6675 52.9447C14.3918 51.5879 11.4153 49.5991 8.90812 47.0919C6.40093 44.5847 4.41213 41.6082 3.05525 38.3325C1.69837 35.0567 1 31.5457 1 28C1 24.4543 1.69838 20.9433 3.05525 17.6675C4.41213 14.3918 6.40094 11.4153 8.90812 8.90811C11.4153 6.40093 14.3918 4.41213 17.6676 3.05525C20.9433 1.69837 24.4543 0.999999 28 1C31.5457 1 35.0567 1.69838 38.3325 3.05525C41.6082 4.41213 44.5847 6.40094 47.0919 8.90812C49.5991 11.4153 51.5879 14.3918 52.9447 17.6676C54.3016 20.9433 55 24.4543 55 28C55 31.5457 54.3016 35.0567 52.9447 38.3325C51.5879 41.6083 49.5991 44.5847 47.0919 47.0919C44.5847 49.5991 41.6082 51.5879 38.3324 52.9448C35.0567 54.3016 31.5457 55 28 55L28 55Z" stroke="#5C86AD" stroke-width="2"/>
            </svg>
        </div>
    </transition>
</template>
<script setup lang="ts">


import {useLoadingStore} from '../app/store/store';

const loading = useLoadingStore()

</script>
<style lang="sass">
.v-enter-active,
.v-leave-active
    transition: .3s ease-in-out
    transition-property: opacity
    opacity: 1
    pointer-events: auto
.v-enter-from,
.v-leave-to
    opacity: 0
    pointer-events: none
</style>